import notifyModal from "./notifyModal";

function initSubmitForms() {
    const $ = require("jquery");
    window.jQuery = $;
    window.$ = $;

    $(".submit-form").on("click", function (e) {
        e.preventDefault();
        var submit = $(this);
        var form = $(this).closest("form");
        var link = form.attr("action");

        $.each(form.find("span.text-danger"), function (key, value) {
            $(this).text("");
            $(this).siblings("input").removeClass("has-danger");
        });

        $.ajax({
            url: link,
            method: "post",
            dataType: "json",
            data: form.serialize(),
            success: function (data) {
                if (data.redirectTo != undefined) {
                    document.location.href = data.redirectTo;
                } else if (data.message != undefined) {
                    notifyModal(data.message);
                }
                MicroModal.close("modal-authorization");
                MicroModal.close("modal-forget-password");
            },
            error: function (err) {
                var fg, span;
                if (err.status == 422 || err.status == 423) {
                    $.each(err.responseJSON.errors, function (key, value) {
                        var input = $('input[name="' + key + '"]', form);
                        input.addClass("has-danger");
                        span = input.siblings("span");
                        if (!span.length) span = input.siblings("span.error");
                        if (value[0] instanceof Object) {
                            var errs = "";
                            $.each(value[0], function (key, value) {
                                errs += value + "<br>";
                            });
                            span.html(errs);
                        } else span.html(value[0]);
                        //span.show();
                    });

                    if (err.responseJSON.flash != undefined) {
                        notifyModal(err.responseJSON.flash);
                    }
                } else {
                    notifyModal(
                        "Неправильный ответ от сервера, попробуйте позже!"
                    );
                }
            },
            complete: function (e) {
            },
        });
        return false;
    });
}

export default initSubmitForms;
